<template>
  <div></div>
</template>
<script>
import {
  ApiLogin,
  ApiForgotPassword,
  ApiConfirmPassword,
  ApiActivateUser,
} from "../http/apis/Login";
export default {
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
        confirmpw: "",
      },
    };
  },
  async mounted() {
    if (this.$route.query.mail !== undefined) {
      this.login();
    }
  },
  methods: {
    login() {
      window.localStorage.setItem("token_web", this.$route.query.token);
      const todayTimestamp = Math.floor(Date.now() / 1000);
      this.$store.dispatch("auth/setAuth", {
        token: this.$route.query.token,
        isLogin: true,
        userid: this.$route.query.userid,
        username: this.$route.query.username,
        email: this.$route.query.mail,
        permit: this.$route.query.permit,
        todayTimestamp: todayTimestamp,
        image: this.$route.query.image,
      });
      this.$store.dispatch("courseInfo/clearAllAssignment");
      this.$router.push({
        path: "/course",
      });
      //   ApiLogin.post(this.loginForm)
      //     .then((response) => {
      //       console.log(response);
      //       window.localStorage.setItem("token", response.record);
      //       //vuex
      //       this.$store.dispatch("auth/setAuth", {
      //         token: response.record,
      //         isLogin: response.status === "success" ? true : false,
      //         userid: response.userID,
      //         username: response.username,
      //         email: response.email,
      //         permit: response.permit,
      //         todayTimestamp: todayTimestamp,
      //         image: response.image,
      //       });
      //       this.$store.dispatch("courseInfo/clearAllAssignment");
      //       // response.status === "success"
      //       if (response.status === "success") {
      //         this.$router.push({
      //           path: "/course",
      //         });
      //       } else {
      //         this.$bus.$emit(
      //           "messsage:push",
      //           "Oh snap ! Your email or password is incorrect. please try again.",
      //           "danger"
      //         );
      //       }
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //     });
    },
  },
};
</script>
<style lang="scss" scoped></style>
